import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import styled from 'styled-components';
import { Spacer } from '../Spacer';
var Container = styled(Spacer).withConfig({
  displayName: "MenuItem__Container",
  componentId: "sc-1j5x6k6-0"
})(function (_ref) {
  var colors = _ref.theme.colors,
      onClick = _ref.onClick;
  return "\n  height: 48px;\n  transition: 200ms background-color;\n  text-align: left;\n  " + (onClick && 'cursor: pointer;') + ";\n\n  &:hover, &:focus {\n    background-color: " + colors.grey.lighter + ";\n  }\n\n  &:active {\n    background-color: " + colors.grey.light + ";\n  }\n";
});
export var MenuItem = function MenuItem(_ref2) {
  var onClick = _ref2.onClick,
      children = _ref2.children,
      _ref2$dataTest = _ref2['data-test'],
      testId = _ref2$dataTest === void 0 ? 'menu-item' : _ref2$dataTest,
      otherStyleProps = _objectWithoutPropertiesLoose(_ref2, ["onClick", "children", "data-test"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    py: 3,
    px: 4,
    backgroundColor: "base.white",
    onClick: onClick,
    "data-test": testId,
    alignItems: "center",
    space: "xxs"
  }, otherStyleProps), children);
};